const unionLogin = {
  path: 'unionLogin',
  component: resolve => require(['../../../components/pages/unionLogin'], resolve)
}

export default unionLogin
